"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Suggestions = void 0;
var _SuggestionsPage = require("./SuggestionsPage");
var _jsxRuntime = require("react/jsx-runtime");
const Suggestions = props => {
  const {
    activeFilter,
    currentPage
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: Array.from({
      length: currentPage + 1
    }).map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_SuggestionsPage.SuggestionsPage
    // eslint-disable-next-line react/no-array-index-key -- should be fine in this case
    , {
      isLastPage: i === currentPage,
      pageNumber: i,
      ...props
    }, `${activeFilter}-${i}`))
  });
};
exports.Suggestions = Suggestions;